<div id="shared-notification-snackbar" class="snackbar">
  <div id="shared-notification-snackbar-content" class="snackbar-left">
    <div id="shared-notification-snackbar-icon-wrapper">
      <mat-icon id="shared-notification-snackbar-icon" class="snackbar-icon">{{
        getIcon
      }}</mat-icon>
    </div>
    <div class="snackbar-data" id="shared-notification-snackbar-text">
      <ng-container
        id="shared-notification-snackbar-text-headline-wrapper"
        *ngIf="msgHeading"
      >
        <app-text
          id="shared-notification-snackbar-text-headline"
          class="snackbar-heading"
          [textStyleType]="'headline4'"
          >{{ msgHeading }}</app-text
        >
      </ng-container>
      <ng-container
        id="shared-notification-snackbar-text-description-wrapper"
        *ngIf="msgDescription"
      >
        <app-text
          id="shared-notification-snackbar-text-description"
          *ngIf="msgDescription"
          class="snackbar-description"
          [textStyleType]="'body2'"
          >{{ msgDescription }}</app-text
        >
      </ng-container>
    </div>
  </div>
  <div id="shared-notification-snackbar-close-icon-wrapper" class="snackbar-right">
    <mat-icon
      id="shared-notification-snackbar-close-icon"
      class="snackbar-close-icon"
      (click)="snackBarRef.dismiss()"
      >close</mat-icon
    >
  </div>
</div>
